import { MoneyType } from "../../../api/api";
import { IAction, INumericValueAction } from "../../redux/actions";

export interface ICurrencyFormat {
  iso: string;
  symbol?: string;
  decimals: number;
  decimalDivider: string;
  thousandsDivider: string;
  coinsDivider?: string;
  showCurrencyChar: boolean;
}

export interface ICurrencyValueAction extends IAction {
  value: ICurrencyFormat;
}

export interface IMoneyTypeValueAction extends IAction {
  value: MoneyType;
}

export interface IMoneyTypesValueAction extends IAction {
  values: MoneyType[];
}

export enum types {
  TRIGGER_BET_DENOMINATION_CHANGE_REQUEST = "TRIGGER_BET_DENOMINATION_CHANGE_REQUEST",
  TRIGGER_BET_LEVEL_CHANGE_REQUEST = "TRIGGER_BET_LEVEL_CHANGE_REQUEST",
  TRIGGER_CHANGE_MONEY_TYPE = "TRIGGER_CHANGE_MONEY_TYPE"
}

export const triggerBetDenominationChangeRequest = (
  value: number
): INumericValueAction => {
  return {
    type: types.TRIGGER_BET_DENOMINATION_CHANGE_REQUEST,
    value
  };
};

export const triggerBetLevelChangeRequest = (
  value: number
): INumericValueAction => {
  return {
    type: types.TRIGGER_BET_LEVEL_CHANGE_REQUEST,
    value
  };
};

export const triggerMoneyTypeChangeRequest = (
  value: MoneyType
): IMoneyTypeValueAction => {
  return {
    type: types.TRIGGER_CHANGE_MONEY_TYPE,
    value
  };
};
